import * as yup from 'yup'
import {
  _brandName,
  _email,
  _companyName,
  _sales,
  _genders,
  _categoryList,
  _countryOfOrigin,
  _description,
  _instagramUrl,
  _websiteUrl,
  _foundedInYear,
  _mainContactName,
  _mainContactPhone,
  _prefixContactPhone,
  _goals,
} from './config'

const currentYear = new Date().getFullYear()
const urlRegexp = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-?&]*)*\/?$/

export const brandValidationSchema = yup.object().shape({
  [_brandName]: yup
    .string()
    .required('This field cannot be left blank')
    .max(100, 'Name is too long'),
  [_companyName]: yup.string().required('This field cannot be left blank'),
  [_mainContactName]: yup.string().required('This field cannot be left blank'),
  [_genders]: yup
    .array()
    .of(yup.string())
    .min(1, 'Please select at lease one variant')
    .required('This field cannot be left blank'),
  [_foundedInYear]: yup
    .number()
    .min(1500, 'Please provide valid year')
    .max(currentYear, 'Date cannot be in the future')
    .integer('Please provide valid year')
    .required('This field cannot be left blank'),
  [_countryOfOrigin]: yup.string().required('This field cannot be left blank'),
  [_email]: yup
    .string()
    .email('Invalid email address format. Eg. example@gmail.com')
    .required('This field cannot be left blank'),
  [_websiteUrl]: yup
    .string()
    .matches(
      urlRegexp,
      'Please provide valid URL address (ex. https://flip.shop/)'
    )
    .required('This field cannot be left blank'),
  [_instagramUrl]: yup
    .string()
    .matches(
      urlRegexp,
      'Please provide valid URL address (ex. https://www.instagram.com/joinflip)'
    )
    .required('This field cannot be left blank'),
  [_sales]: yup.string(),
  [_categoryList]: yup.array().of(yup.string()),
  [_description]: yup.string().required('This field cannot be left blank'),
  [_prefixContactPhone]: yup
    .string()
    .required('This field cannot be left blank'),
  [_mainContactPhone]: yup
    .string()
    .required()
    .matches(/^[0-9]+$/, 'Incorrect phone number')
    .min(4, 'Incorrect phone number')
    .max(12, 'Incorrect phone number')
    .required('Field is required'),
  [_goals]: yup.array().of(yup.string()),
})
